export default __webpack_public_path__ + "static/media/black_friday_homepage_slide2.d0579c24.png";